import { elements } from '#components/generics/js/styles.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'
import object from '@mailobj-browser/front/js/utils/object.js'

const handlers = new WeakMap()
const templates = new WeakMap()
const wrappers = new WeakMap()

const onClick = object(listener, {
  type: click,
  passive,
  task: async button => {
    const wrapper = wrappers.get(button)
    const buttons = closest(`.${elements.buttons}`, button)
    const set = one('[type="hidden"][name*="_set"]', wrapper)
    const nb = one('[type="hidden"][name*="_nb"]', wrapper)

    await handlers.get(button)?.(button, templates.get(wrapper), buttons, set, nb)
  }
})

export const handle = (button, handler) => {
  handlers.set(button, handler)
  wrappers.set(button, closest('[data-contract~="fieldsCollection.add.wrapper"]', button))
  onClick.listen(button)

  queueMicrotask(async () => {
    await removed(button)
    handlers.delete(button)
    wrappers.delete(button)
  })
}

export default wrapper => {
  templates.set(wrapper, one('template', wrapper))

  queueMicrotask(async () => {
    await removed(wrapper)
    templates.delete(wrapper)
  })
}